import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import { HttpError, HttpService } from 'src/toolkit';

import { TSliceInitialState, useAppSelector } from '../../hooks';
import { TApplication, TApplicationResponse, adaptApplicationFromResponse } from '../../types';
import { BACKEND_ADMIN_APPLICATION } from '../../backend-paths';


export const applicationReadGetApi = createAsyncThunk(
	`FETCH/${BACKEND_ADMIN_APPLICATION}/:id`,
	(payload: number, thunkApi) => {
		const path = `${BACKEND_ADMIN_APPLICATION}/${payload}`;

		return HttpService.get<TApplicationResponse>(path).then(result => {
			return adaptApplicationFromResponse(result.data);
		}).catch((error: HttpError) => {
			return thunkApi.rejectWithValue({ ...error });
		});
	},
);

const initialState: TSliceInitialState<TApplication> = {
	item: undefined,
	isLoading: false,
	error: undefined,
};

export const applicationReadSlice = createSlice({
	name: 'applicationReadSlice',
	initialState,
	reducers: {
		setApplicationRead(state, action: PayloadAction<TApplication>) {
			state.item = action.payload;
		},

		clearApplicationRead(state) {
			return { ...initialState };
		},
	},

	extraReducers: {
		[applicationReadGetApi.pending.type]: (state) => {
			state.isLoading = true;
			state.error = undefined;
		},

		[applicationReadGetApi.fulfilled.type]: (state, action: PayloadAction<TApplication>) => {
			state.isLoading = false;
			state.item = action.payload;
		},

		[applicationReadGetApi.rejected.type]: (state, action: PayloadAction<HttpError>) => {
			state.isLoading = false;
			state.error = action.payload;
		},
	},
});

export const useApplicationReadSelector = () => useAppSelector(state => state[applicationReadSlice.name]);

export const { clearApplicationRead, setApplicationRead } = applicationReadSlice.actions;
